module.exports = __webpack_public_path__ + "static/media/trash.750d2086.svg";